'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rowItem = require('./row-item.scss');

var _rowItem2 = _interopRequireDefault(_rowItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
    className: _propTypes2.default.string,
    containerRef: _propTypes2.default.func
};

var defaultProps = {
    className: '',
    containerRef: undefined
};

var GenericRowItem = function GenericRowItem(props) {
    return _react2.default.createElement(
        'div',
        {
            className: _rowItem2.default.rowItem + ' ' + props.className,
            ref: props.containerRef
        },
        props.children
    );
};

GenericRowItem.propTypes = propTypes;
GenericRowItem.defaultProps = defaultProps;
exports.default = GenericRowItem;